import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Rating } from "@mui/material";
import "./Product.css";
import { styled } from "@mui/material/styles";
import { Spinner } from "react-bootstrap";

function Product({ product }) {
  const [isLoading, setIsLoading] = useState(true);
  const StyledRating = styled(Rating)({
    "& .MuiRating-iconFilled": {
      color: "#c7a43f",
    },
  });
  return (
    <>
      {isLoading && (
        <div
          key={product.id}
          className="col-lg-3 mx-2 d-flex justify-content-center align-items-center product no-image loading-image rounded shadow"
        >
          <Spinner animation="border" variant="warning" />
        </div>
      )}
      <Link
        to={`/product/${product.slug}`}
        className={`${
          isLoading && "d-none"
        } product d-flex text-dark m-0 p-0 animate__animated animate__fadeIn animate__slower`}
      >
        <div className="card product-smaller border-0">
          <img
            src={process.env.REACT_APP_IMAGES_URL + "/" + product.images.img1}
            className="card-img-top"
            alt="..."
            onLoad={() => setIsLoading(false)}
          />
          <div className="card-body p-0 text-start">
            <p className="card-text m-0 fs-7 text-responsive hover-underline">
              {product.name}
            </p>
            <StyledRating
              name="read-only"
              value={product.rating}
              className="fs-5"
              readOnly
            />
            <div className="mb-0 text-responsive">
              {product.sale ? (
                <>
                  <div className="mb-1">
                    <strong className="f-roboto text-yellow">
                      ${(product.price * 1).toFixed(2)}
                    </strong>
                    <del className="f-roboto ms-2">
                      {(product.price * 1.1).toFixed(2)}{" "}
                    </del>
                  </div>
                  <div className="bg-yellow f-roboto rounded-3 text-white d-inline text-center px-2 fs-8 py-1">
                    SALE
                  </div>
                </>
              ) : (
                <strong className="f-roboto">${product.price}</strong>
              )}
            </div>
          </div>
        </div>
      </Link>
    </>
  );
}

export default Product;
